<template>
    <v-row fill-height style="background-color:black">
        <v-icon
            v-show="novidades.length > 1"
            class="container-icon v-icon-left"
            @click="sliderAtual--"
        >mdi-chevron-left</v-icon>
        <v-icon
            v-show="novidades.length > 1"
            class="container-icon v-icon-right"
            @click="sliderAtual++"
        >mdi-chevron-right</v-icon>
        <v-carousel class="my-0" v-model="sliderAtual" height="auto" hide-delimiters :show-arrows="false">
          <v-carousel-item  v-for="(item, i) in novidades" :key="i">
            <v-img 
              v-if="item.dsMedia == 'imagem'"
              :src="$drink_img_uri + item.dsImagem" contain></v-img>
            <div class="iframe-center mt-1" v-if="item.dsMedia == 'video'">
                <iframe loading="lazy"  ref="youtube"  frameborder="0" :src="getYoutubeEmbed(item.dsVideo)"></iframe>
            </div>
          </v-carousel-item>
        </v-carousel>
    </v-row>
</template>
<style scoped>
.container-icon {
  z-index: 1000;
  top: 50vh;
  width: auto;
}
iframe {
  height: calc(100vh - 136px);
  width: 100%;
}
.ytp-chrome-top {
  display: none !important;
}
.iframe-center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.v-icon-left {
  left: 10px;
  position: fixed !important;
}

.v-icon-right {
  right: 10px;
  position: fixed !important;
}
.v-icon { 
  font-size: 55px !important;
  opacity: 0.8 !important;
  background-color: #333 !important;
  color: transparent !important;
  text-shadow: 0px 0 1px rgb(255 255 255);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
}
.v-carousel { 
  position: relative;
  margin:68px 0px;
  
}
</style>
<script>

export default {
  name: "CarouselNovidades",
  data() { 
    return { 
      sliderAtual:0
    }
  },
  props: { 
    novidades: { 
      type: Array
    }
  },
  methods: { 
    getYoutubeEmbed(url) {
      window.console.log(url)
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      const id = match && match[2].length === 11 ? match[2] : null;

      if (id) {
        return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&autohide=1&showinfo=0&controls=1&enablejsapi=1`;
      }

      return null;
    },
  }
}
</script>
